import * as React from 'react';
import { Header, Icon, Segment, Modal, Button } from 'semantic-ui-react';
import { ActionModalContentProps } from '../interfaces/ActionModalProps';

const VoidModal = (props: ActionModalContentProps) => (
  <Modal
    basic
    size='tiny'
    closeIcon
    onClose={props.onCloseModal}
    open={props.actionModalForm.open}
  >
    <Modal.Header>
      Confirm Decline
    </Modal.Header>
    <Modal.Content>
      <Modal.Description>
        Are you sure you wish decline the transaction?
      </Modal.Description>
      <Modal.Description>
        The transaction will no longer be visible to members.
        </Modal.Description>
      {props.transactionFormTouched &&
        <Modal.Description>
          <strong>Change made to the transaction form will <i>not</i> be saved.</strong>
        </Modal.Description>
      }
    </Modal.Content>
    <Modal.Actions>
      <Button
        color='grey'
        labelPosition='right'
        icon='undo'
        content='Close'
        inverted
        size='tiny'
        onClick={props.onCloseModal}
      />
      <Button
        color='olive'
        labelPosition='right'
        icon='thumbs down'
        content='Decline'
        inverted
        size='tiny'
        onClick={props.onConfirm}
      />
    </Modal.Actions>
  </Modal>
)

export default VoidModal